import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    section: 'bg-bg-items-white py-18 max-md:py-10',
    container: 'container',
    base: 'flex gap-[110px] max-xl:gap-15 max-lg:gap-8 max-md:flex-col-reverse',
    left: 'flex w-[490px] shrink-0 flex-col gap-4 max-xl:w-[450px] max-lg:w-[390px] max-md:w-full',
    right: 'grow max-md:hidden',
    title: 'heading-2xl',
    description: 'heading-m',
    rubrics: 'flex flex-col gap-3',
    buttonChildren: 'flex items-center gap-5',
    button: 'mr-auto !pl-0',
    articleButton: 'md:hidden'
  }
});
